import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentCache } from 'src/core-lib/navigation/services/content-cache.service';
import { OverlayService } from 'src/layout/overlay/services/overlay.service';
import { Language, Languages } from '../../models/main-configuration.model';

@Component({
    selector: 'app-overlay-languages',
    templateUrl: './overlay-languages.component.html',
    styleUrls: ['./overlay-languages.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayLanguagesComponent {
    languages: Languages;
    currentLanguage: Partial<Language>;


    constructor(
        private contentCache: ContentCache,
        private overlaySerivce: OverlayService
    ) {

        this.languages = this.contentCache.get<Languages>('languages');
        this.currentLanguage = this.contentCache.get<Language>('currentLanguage');
    }

    setLanguage(lang: Language): void {
        try {
            window.location.href = window.location.href.replace(this.currentLanguage.isoCode, lang.isoCode);
        } catch {

        }
    }
    close() {
        this.overlaySerivce.close();
    }
}




